import React from 'react'
import Link from 'next/link'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import ArrowIcon from 'icons/Arrow'
import PageHeader from 'components/PartnershipsSite/PageHeader'
import PartnershipsCTAButton from 'components/PartnershipsSite/PartnershipsCTAButton'
import { usePageView } from 'hooks'
import { getStaticWrapper, THEME } from 'utils'

const VerticalBox = ({ name, image, link }) => {
  return (
    <React.Fragment>
      <Link href={`/partnerships/verticals/${link}`}>
        <a className='verticalsIndex__vertical' style={{ backgroundImage: `url(${image})` }}>
          <h4>{name}</h4>
          <Link href={`/partnerships/verticals/${link}`}>
            <a>
              Learn More
              <span>
                <ArrowIcon width='100%' height='auto' direction={'right'} color={'#f2f1f0'} />
              </span>
            </a>
          </Link>
        </a>
      </Link>
      <style>{`
      .verticalsIndex__vertical {
        background-size: cover;
        padding-left: 8%;
        display: flex;
        flex-direction: column;
        color: #ffffff;
      }
      .verticalsIndex__vertical h4 {
        font-size: 4vw;
        margin: auto 0 3%;
        width: 66%;
        line-height: 1.35;
      }
      .verticalsIndex__vertical a {
        font-size: 2.35vw;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: bold;
        color: #ffffff;
        margin: 0 0 8%;
        max-height: 5%;
      }
      .verticalsIndex__vertical span {
        width: 7%;
        display: flex;
      }
      @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
        .verticalsIndex__vertical h4 {
          font-size: 2.5vw;
        }
        .verticalsIndex__vertical a {
          font-size: 1.4vw;
          margin: 0 0 8%;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
        .verticalsIndex__vertical h4 {
          font-size: 1.9rem;
        }
        .verticalsIndex__vertical a {
          font-size: 1.05rem;
          margin: 0 0 8%;
        }
      }
      `}</style>
    </React.Fragment>
  )
}

const VerticalIndex = () => {
  usePageView()

  const verticalData = [
    {
      name: 'Behind Barstool',
      link: 'behind-barstool',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/daily.f7250b8c.png'
    },
    {
      name: 'El Presidente',
      link: 'el-presidente',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/el_pres.ea6e5df4.png'
    },
    {
      name: 'Barstool Football',
      link: 'barstool-football',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/football.052a19e3.png'
    },
    {
      name: 'Barstool Baseball',
      link: 'barstool-baseball',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/baseball.86b35ed1.png'
    },
    {
      name: 'Barstool Golf',
      link: 'barstool-golf',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/golf.0f97daca.png'
    },
    {
      name: 'Barstool Hockey',
      link: 'barstool-hockey',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/hockey.2c6f8ee0.png'
    },
    {
      name: 'Barstool Combat',
      link: 'barstool-combat',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/combat.321554a6.png'
    },
    {
      name: 'Barstool Soccer',
      link: 'barstool-soccer',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/soccer.0e1a4c97.png'
    },
    {
      name: 'Barstool Sportsbook',
      link: 'barstool-sportsbook',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/sportsbook.9f4d782d.png'
    },
    {
      name: 'Barstool Lifestyle & Entertainment',
      link: 'barstool-lifestyle-entertainment',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/lifestyle.bb77339e.png'
    },
    {
      name: 'Barstool Travel & Outdoors',
      link: 'barstool-travel-outdoors',
      image: 'https://chumley.barstoolsports.com/union/2021/02/12/Donnie_600x600.52f9108a.png'
    },
    {
      name: 'Barstool Gaming',
      link: 'barstool-gaming',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/gaming.474ca992.png'
    },
    {
      name: 'Female Lifestyle',
      link: 'barstool-female-lifestyle',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/female.8356ac2e.png'
    },
    {
      name: 'Barstool Business & News',
      link: 'barstool-business-news',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/business.7d0d5851.png'
    },
    {
      name: 'Barstool Cities',
      link: 'barstool-cities',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/chicago.4ef88eb0.png'
    },
    {
      name: 'Barstool Military',
      link: 'barstool-military',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/military.f0ac40e5.png'
    },
    {
      name: 'Barstool Basketball',
      link: 'barstool-basketball',
      image: 'https://chumley.barstoolsports.com/union/2021/02/02/basketball.e51cb71c.png'
    },
    {
      name: 'Barstool Food',
      link: 'barstool-food',
      image: 'https://chumley.barstoolsports.com/union/2021/02/09/Food.a90834e8.png'
    }
  ]

  return (
    <PartnershipsLayout
      background='#D8D8D8'
      title='Barstool Sports Verticals - All Verticals & Franchises - Advertise with Barstool Sports'
    >
      <div className='verticalsIndex'>
        <PageHeader
          title={'OUR VERTICALS'}
          details={
            'Barstool has over 65 content franchises that resonate with an extremely engaged audience across sports, entertainment, lifestyle, business, finance, and more.'
          }
        />
        <Link href={'/partnerships/verticals/' + verticalData[0].link}>
          <a className='verticalsIndex__featured'>
            <img src={verticalData[0].image} alt='verticals_featured' />
            <h2>{verticalData[0].name}</h2>
            <p>The behind the scenes action at Barstool HQ</p>
            <PartnershipsCTAButton
              className='verticalsIndex__cta'
              text='Learn More'
              link={'/partnerships/verticals/' + verticalData[0].link}
            />
          </a>
        </Link>
        <div className='verticalsIndex__grid'>
          {verticalData.map((item, idx) => (idx > 0 ? <VerticalBox key={idx} {...item} /> : null))}
        </div>
      </div>
      <style jsx>{`
        .verticalsIndex {
          width: 100%;
          margin: 0 auto;
          background: #f5f5f5;
          display: flex;
          flex-direction: column;
          align-items: center;
          // overflow: hidden;
        }
        .verticalsIndex__featured {
          width: 100%;
          position: relative;
          color: #ffffff;
          overflow: hidden;
        }
        .verticalsIndex__featured > img {
          width: 100%;
          margin: -5% 0;
        }
        .verticalsIndex__featured > h2 {
          position: absolute;
          left: 8%;
          bottom: 32%;
          font-size: 4.5vw;
          margin: 0;
        }
        .verticalsIndex__featured > p {
          position: absolute;
          left: 8%;
          bottom: 21%;
          font-weight: bold;
          font-size: 2.35vw;
          margin: 0;
          width: 100%;
        }
        .verticalsIndex__grid {
          width: 100%;
          display: grid;
          color: #ffffff;
          padding: 4% 2%;
          grid-template-columns: 1fr 1fr;
          grid-auto-rows: 45vw;
          grid-gap: 2vw;
        }
        @media (min-width: 370px) {
          .verticalsIndex__featured > h2 {
            bottom: 31%;
          }
          .verticalsIndex__featured > p {
            bottom: 22%;
          }
        }
        @media (min-width: 400px) {
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .verticalsIndex__featured > h2 {
            bottom: 31%;
            font-size: 4.4vw;
          }
          .verticalsIndex__featured > p {
            bottom: 23%;
            font-size: 2.25vw;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .verticalsIndex__featured {
            padding: 0 2%;
          }
          .verticalsIndex__featured > h2 {
            left: 12%;
            bottom: 26%;
            font-size: 3.1vw;
          }
          .verticalsIndex__featured > p {
            left: 12%;
            bottom: 20%;
            font-size: 1.6vw;
          }
          .verticalsIndex__grid {
            padding: 2% 2%;
            grid-template-columns: 1fr 1fr 1fr;
            grid-auto-rows: 27vw;
            grid-gap: 1vw;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .verticalsIndex__grid {
            grid-auto-rows: 330px;
            grid-gap: 12px;
          }
          .verticalsIndex__featured > h2 {
            font-size: 2.35rem;
          }
          .verticalsIndex__featured > p {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </PartnershipsLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default VerticalIndex
